"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var store_1 = require("../store/store");
var conversationsLoadedAction_1 = require("../actions/conversationsLoadedAction");
exports.default = satcheljs_1.mutator(conversationsLoadedAction_1.default, function (actionMessage) {
    store_1.default.isLoading = false;
    store_1.default.isError = false;
    if (actionMessage.recipientEmail) {
        store_1.default.emailRecipientConversations.set(actionMessage.recipientEmail, actionMessage.conversations);
    }
});
//# sourceMappingURL=conversationsLoadedMutator.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-subject-picker-store/lib/mutators/conversationsLoadedMutator.js
// module id = 2153
// module chunks = 2 3 4 45 108